<template>
    <div class="page-total-container">
        <Header></Header>
        <div class="page-container">
            <div class="page-back-wrapper">
                <div class="page-back" @click="handleBack">
                    <img src="@/assets/img/back.png" alt="" class="page-back-img">
                    <span>返回</span>
                </div>
            </div>
        </div>

        <div class="page-content-wrapper">
            <div class="slider-container">
                <div class="slider-wrapper">
                    <div :class="activeSlider == 'basic' ? 'slider-item-active' : 'slider-item'"
                        @click="handleSlider('basic')">
                        <div class="slider-content">
                            <img src="@/assets/img/graph-3.png" alt="" class="slider-img">
                            <span class="slider-label">基本统计</span>
                        </div>
                    </div>
                    <div :class="activeSlider == 'plan' ? 'slider-item-active' : 'slider-item'"
                        @click="handleSlider('plan')">
                        <div class="slider-content">
                            <img src="@/assets/img/chart-2.png" alt="" class="slider-img">
                            <span class="slider-label">学习计划统计</span>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="activeSlider == 'basic'" class="content-wrapper">
                <div class="page-content-container">
                    <div class="page-person-header">
                        {{ username }}的学习报告
                    </div>
                    <div class="page-content-header">
                        <div class="page-header-block"></div>
                        <div class="page-content-header-item-active">学习统计</div>
                    </div>
                    <div class="page-menmber-container member-card-container">
                        <div class="page-menmber-wrapper">
                            <div class="page-member-left">
                                <div class="card-container">
                                    <div class="card-item">
                                        <div class="card-image-wrapper">
                                            <img src="@/assets/img/statistical3.png" alt="" class="card-img">
                                        </div>
                                        <div class="card-content">
                                            <div class="card-title">观看进度</div>
                                            <div class="card-data">
                                                {{ statisticsInfo.watchTotalProgress }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card-item">
                                        <div class="card-image-wrapper">
                                            <img src="@/assets/img/statistical1.png" alt="" class="card-img">
                                        </div>
                                        <div class="card-content">
                                            <div class="card-title">观看总时长</div>
                                            <div class="card-data">
                                                {{ statisticsInfo.watchTotalTime }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="page-member-right">
                                <div class="card-container">
                                    <div class="card-item">
                                        <div class="card-image-wrapper">
                                            <img src="@/assets/img/clock.png" alt="" class="card-img">
                                        </div>
                                        <div class="card-content">
                                            <div class="card-title">最近一次学习时间：</div>
                                            <div class="card-data">
                                                {{ statisticsInfo.lastStudyTime || '00:00:00' }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="page-content-container" style="margin-top:18px;">
                    <div class="page-content-header page-branch">
                        <div class="page-header-block"></div>
                        <div class="page-content-header-item-active">学习详情</div>
                    </div>
                    <div class="menmber-table-container">
                        <div class="menmber-table-wrapper">
                            <List :mode="listMode" :tableData="tableData"></List>
                            <div v-if="tableData.length > 0 && currentPage < totalPages" class="view-more-btn"
                                @click="viewMore">查看更多</div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="activeSlider == 'plan'" class="content-wrapper">
                <MemberPlan @reportRow="getReportRow"></MemberPlan>
            </div>
        </div>
    </div>
</template>

<script>
import Header from '@/components/Header.vue'
import MemberPlan from './MemberPlan.vue'
import { getMemberDetailStatistics, getCourseDetailMemberList } from '@/api/index.js';
import List from '@/components/List.vue'
import IOdometer from 'vue-odometer';
import 'odometer/themes/odometer-theme-default.css';
export default {
    name: '',
    components: {
        Header,
        MemberPlan,
        List,
        IOdometer
    },
    data() {
        return {
            dept: '',
            token: '',
            activeSlider: 'basic',
            reportData: {},
            userDept: '',
            username: "",
            cardData: {
                progress: 0,
                hours: 0,
                time: [0, 0, 0]
            },
            statisticsInfo: {},
            listMode: "study-member-report-detail",
            tableData: [],
            userId: 0,
            currentPage: 1,
            totalPages: 1,
            pageMode: ''
        }
    },
    created() {
        scrollTo(0, 0);
        // this.dept = this.$route.params.dept;
        //  this.token = window.localStorage.getItem('token');
        this.userId = this.$route.params.id;
        this.userDept = this.$route.params.userDept;

        this.pageMode = this.$route.params.mode;

        this.token = localStorage.getItem('token');
        this.dept = localStorage.getItem('dept');
        this.statisticsData();
        this.getMemberList();
    },
    mounted() {

    },
    methods: {
        handleBack() {
            this.$router.go(-1);
            // switch (this.pageMode) {
            //     case 'study-report':
            //         this.$router.push(`/index/study-report-member/${this.dept}/${this.token}`);
            //         break;
            //     case 'echarts-report':
            //         // var planData=window.localStorage.getItem('plan');
            //         // this.$router.push(`/echartsReport/${planData.id}`);
            //         this.$router.push(`/studyPlan/manage-plan`);
            //         break;
            // }
        },
        handleSlider(target) {
            this.activeSlider = target;
        },
        getReportRow(row) {
            var reportData = JSON.parse(row);
            //   this.dept = this.$route.params.dept;
           this.dept = window.localStorage.getItem('dept');
            this.userId = reportData.userId;
            this.userDept = reportData.deptId;
            this.activeSlider = 'basic';
            this.statisticsData();
            this.getMemberList();
            scrollTo(0, 0);
        },
        statisticsData() {
            getMemberDetailStatistics(this.userDept, this.userId, {}, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    var data = res.data;
                    this.username = data.name;
                    this.statisticsInfo = data;
                    //this.cardInit(data);
                }
                return;
            }).catch(err => {
                // console.log(err);
            });
        },
        cardInit(data) {
            var progress = parseInt(data.watchTotalProgress);
            var hours = parseInt(data.watchTotalTime);
            this.$nextTick(function () {
                this.cardData = {
                    progress: progress,
                    hours: hours,
                    time: [11, 27, 5]
                }
            });
        },
        getMemberList() {
            getCourseDetailMemberList({
                deptId: this.userDept,
                pageNum: this.currentPage,
                pageSize: 10,
                userId: Number(this.userId)
            }, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    var data = res.data;
                    this.totalPages = data.totalPages;
                    var lastData = this.tableData;
                    this.tableData = lastData.concat(data.list);
                } else {
                    this.$message.error(res.msg);
                }
                return;
            }).catch(err => {
                // console.log(err);
            });
        },
        viewMore() {
            var currentPage = this.currentPage;
            if (currentPage < this.totalPages) {
                this.currentPage = currentPage + 1;
                this.getMemberList();
            } else {
                this.$message({
                    message: '没有更多了',
                    type: 'warning'
                });
            }
        }
    }
}
</script>

<style scoped>
.page-total-container {
    padding-bottom: 18px;
}

.page-container {
    width: 1200px;
    margin: 0 auto;
    margin-bottom: 18px;
}

.page-back-wrapper {
    width: 100%;
    height: 68px;
    background: #FFFFFF;
    box-shadow: 0px 5px 20px 0px rgba(149, 154, 170, 0.15);
    border-radius: 8px;
    border: 1px solid #F0F0F3;
    display: flex;
    align-items: center;
    margin-top: 118px;
}

.page-back-img {
    width: 20px;
    height: 20px;
    margin-right: 8px;
    display: inline-block;
    position: relative;
    top: 2px;
}

.page-back {
    display: flex;
    align-items: center;
    margin-left: 30px;
    cursor: pointer;
}

.page-content-wrapper {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    margin-top: 18px;
}

.slider-container {
    width: 180px;
    background: linear-gradient(141deg, #4A6BEA 0%, #7995FF 100%);
    border-radius: 8px;
}

.content-wrapper {
    width: 1000px;
    /* flex:1; */
    margin-left: 18px;
}

.slider-wrapper {
    margin-top: 47px;
}

.slider-item {
    display: flex;
    height: 38px;
    color: #fff;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    margin-bottom: 15px;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}

.slider-item:hover {
    cursor: pointer;
    opacity: 0.8;
}

.slider-item-active {
    background: linear-gradient(90deg, #5580F5 0%, #72A3F5 100%);
    display: flex;
    height: 38px;
    color: #fff;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    margin-bottom: 15px;
    cursor: pointer;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}

.slider-content {
    height: 100%;
    display: flex;
    align-items: center;
    margin-left: 30px;
}

.slider-img {
    width: 18px;
    height: 19px;
}

.slider-label {
    margin-left: 15px;
}

.page-content-container {
    width: 100%;
    background: #FFFFFF;
    box-shadow: 0px 5px 20px 0px rgba(149, 154, 170, 0.15);
    border-radius: 8px;
    border: 1px solid #F0F0F3;
}

.page-person-header {
    font-size: 22px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #000000;
    padding: 30px 0px 0px 0px;
    text-align: center;
}

.page-content-header {
    width: 100%;
    height: 80px;
    line-height: 80px;
    position: relative;
    display: flex;
    align-items: center;
}

.page-header-block {
    width: 6px;
    height: 24px;
    background: #4F79ED;
    border-radius: 0px 17px 17px 0px;
    position: absolute;
    left: 0px;
    top: 28px;
}

.page-content-header-item-active {
    width: 170px;
    height: 100%;
    text-align: center;
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #4F79ED;
    background: #fff;
    cursor: pointer;
}

.page-menmber-container {
    display: flex;
    padding-bottom: 80px;
    margin-top: 20px;
}

.page-menmber-wrapper {
    flex: 1;
    margin-left: 45px;
    margin-right: 45px;
    display: flex;
}

.menmber-table-container {
    display: flex;
    padding-bottom: 80px;
}

.menmber-table-wrapper {
    flex: 1;
    margin-left: 45px;
    margin-right: 45px;
}

.page-member-left {
    flex: 1;
}

.page-member-right {
    width: 432px;
    margin-left: 30px;
}

.card-container {
    width: 100%;
    display: flex;
    height: 168px;
    background: #FFFFFF;
    box-shadow: 0px 4px 20px 0px rgba(149, 154, 170, 0.1);
    border-radius: 9px;
    border: 1px solid #F0F0F3;
}

.card-item {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
}

.card-title {
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
}

.card-data {
    font-size: 24px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #4F79ED;
    margin-top: 8px;
    display: flex;
}

.card-unit {
    position: relative;
    top: -2px;
}

.card-image-wrapper {
    width: 52px;
    height: 52px;
    border: 2px solid #4F79ED;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    margin-right: 43px;
}

.card-img {
    width: 22px;
    height: 22px;
}

.view-more-btn {
    width: 122px;
    height: 34px;
    border-radius: 20px;
    border: 1px solid #F69264;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #F69568;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    margin-top: 50px;
    margin-bottom: 20px;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}

.view-more-btn:hover {
    cursor: pointer;
    background: #F69264;
    color: #fff;
}
</style>


